/* global BigInt */
import { message } from "antd";
import { dbUserAndHub } from "../../config/api";
import { encryptUserAndHubPayload } from "../../utils/encryption";

import axios from "axios";


export function GenerateShortID(length = 15) {
  const uuid = crypto.randomUUID().replace(/-/g, '');
  let num = BigInt('0x' + uuid);
  let result = '';
    
  const chars = "ABCDEFGHJKLM23459876npqrstuvwxyzNPQRSTUVWXYZ67895432abcdefghjkm";
  const base = BigInt(chars.length);
    
  while (result.length < length) {
      result = chars[Number(num % base)] + result;   // ← use actual base
      num /= base;
  }
    
  return result.slice(0, length);
}


export const handleAddOrEditShop = async ({ shop, mode, token }) => {
  const createStoreAPI = async (data, token) => {
    //Add new Store
    const response = await axios.post(
      dbUserAndHub,
      encryptUserAndHubPayload({
        operationType: "write",
        action: "addBiz",
        biz: data,
        token
      }),
      { headers: { "Content-Type": "application/json" } }
    );
    return response.data; // Parse and return the response data
  };

  const updateStoreAPI = async (data, token) => {
    //Update an existing Store
    const response = await axios.post(
      dbUserAndHub,
      encryptUserAndHubPayload({
        action: "updateBizDetails",
        operationType: "update",
        biz: data,
        token
      }),
      { headers: { "Content-Type": "application/json" } }
    );
    return response.data; // Parse and return the response data
  };

  try {
    let response;
    const storeData = { ...shop };
    delete storeData.bizPasskey;
    delete storeData.confirmPasskey;
    delete storeData.passkey;
    delete storeData.bizSettings;

    if (mode === "edit") {
      response = await updateStoreAPI(storeData, token);
    } else {
      response = await createStoreAPI(storeData, token);
    }

    const statusCode =
      response?.statusCode ??
      response?.data?.statusCode ??
      response?.StatusCode;
    const apiMessage =
      response?.message ??
      response?.data?.message ??
      (typeof response?.body === "string"
        ? (() => {
            try {
              return JSON.parse(response.body)?.message;
            } catch {
              return null;
            }
          })()
        : null);

    if (statusCode != null && Number(statusCode) !== 200) {
      message.error(apiMessage || `Error while saving the Biz (${statusCode})`);
      return null;
    }

    message.success(mode === "edit" ? "Biz updated successfully" : "Biz created successfully");
    return response;
  } catch (err) {
    console.error(err);
    const apiMessage =
      err?.response?.data?.message ||
      err?.response?.data?.data?.message ||
      (typeof err?.response?.data?.body === "string"
        ? (() => {
            try {
              return JSON.parse(err.response.data.body)?.message;
            } catch {
              return null;
            }
          })()
        : null);
    message.error(apiMessage || `Error while saving the Biz`);
    return null;
  }
};

/** Partial Biz update (e.g. gallery keys / display image). Additive fields on `biz`. */
export const updateBizDetailsPatch = async ({ biz, token }) => {
  const response = await axios.post(
    dbUserAndHub,
    encryptUserAndHubPayload({
      action: "updateBizDetails",
      operationType: "update",
      biz,
      token,
    }),
    { headers: { "Content-Type": "application/json" } }
  );
  return response?.data;
};

/** Persist hub-level display image (`HubImageKey` on hub METADATA row). */
export const updateHubDetailsPatch = async ({ hubId, hubImageKey, token }) => {
  const response = await axios.post(
    dbUserAndHub,
    encryptUserAndHubPayload({
      action: "updateHubDetails",
      operationType: "update",
      hubId,
      hubImageKey,
      token,
    }),
    { headers: { "Content-Type": "application/json" } }
  );
  return response?.data;
};

/** Items that reference shared gallery image basenames (for delete confirmation). */
export const findItemsUsingGalleryImageBasenames = async ({
  token,
  hubId,
  bizId,
  imageBasenames,
}) => {
  const response = await axios.post(
    dbUserAndHub,
    encryptUserAndHubPayload({
      operationType: "read",
      action: "findItemsUsingGalleryImageBasenames",
      token,
      hubId,
      bizId,
      imageBasenames,
    }),
    { headers: { "Content-Type": "application/json" } }
  );
  return response?.data;
};

/** Remove shared gallery image entries from affected items (before S3 delete). */
export const unlinkGalleryImagesFromItems = async ({
  token,
  hubId,
  bizId,
  imageBasenames,
}) => {
  const response = await axios.post(
    dbUserAndHub,
    encryptUserAndHubPayload({
      operationType: "update",
      action: "unlinkGalleryImagesFromItems",
      token,
      hubId,
      bizId,
      imageBasenames,
    }),
    { headers: { "Content-Type": "application/json" } }
  );
  return response?.data;
};

 
export const deleteStoreAPI = async (bizToDelete, token) => {
  return await axios.post(dbUserAndHub,
    encryptUserAndHubPayload({
      operationType: "delete",
      action: "deleteBizByUser",
      token,
      biz: {
        hubId: bizToDelete.hubId,
        bizId: bizToDelete.bizId,
      },
      daysToLive: 30,
    }),
    { headers: { "Content-Type": "application/json" } }
  );
};

export const restoreStoreAPI = async (bizToRestore, token) => {
  return await axios.post(
    dbUserAndHub,
    encryptUserAndHubPayload({
      operationType: "delete",
      action: "restoreBizByUser",
      token,
      biz: {
        hubId: bizToRestore.hubId,
        bizId: bizToRestore.bizId,
      },
    }),
    { headers: { "Content-Type": "application/json" } }
  );
};


